import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "OneTimer - Free 24-Hour Online Clock",
  description = "Free 24-hour online clock tool. Perfect for timelapses, productivity tracking, and focused work sessions. Discover OneTimer app for habit tracking.",
  keywords = "24 hour clock, online clock, timer, productivity, time tracking, OneTimer",
  canonical = "https://onetimer-site.firebaseapp.com",
  path = ""
}) => {
  const fullUrl = `${canonical}${path}`;
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content="OneTimer" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="OneTimer" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebApplication",
          "name": "OneTimer",
          "url": canonical,
          "description": "Free 24-hour online clock and productivity tracking tools",
          "applicationCategory": "Productivity",
          "operatingSystem": "Web Browser",
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD"
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEOHead;